import {
    GameStorageManager,
    Inject,
    ISimpleControllerConfiguration,
    ResourceItem,
    ResourceItemType,
    SimpleBaseController,
} from '@denishussar/html5-game-engine';
import { AppStateEnum, GameModel } from './Models/GameModel';
import { GameLogic } from './Logic/GameLogic';
import { GameScreenController, IGameScreenControllerOptions } from './Controllers/Game/GameScreenController';
import { GarageScreenController, IGarageScreenControllerOptions } from './Controllers/Garage/GarageScreenController';
import {
    ILevelSelectionScreenOptions,
    LevelSelectionScreen,
} from './Controllers/Garage/LevelSelectionScreenController';
import {
    ILeaderboardScreenControllerOptions,
    LeaderboardScreenController,
} from './Controllers/Leaderboard/LeaderboardScreenController';
import { ILevelEndOptions, LevelEndController } from './Controllers/LevelEndScreen/LevelEndController';
import { EngineEvents, LevelEvents, UIEvents } from './Constants/Events';
import { IUIOptions, UIController } from './Controllers/UI/UIController';
import { INameScreenOptions, NameScreenController } from './Controllers/NameScreenController';
import { Sounds } from './Constants/Sounds';
import { SoundModel } from './Models/SoundModel';
import { Backend } from './Backend';
import { searchParam } from './Common/Utils';
import { RepairModalController } from './Controllers/LevelEndScreen/LevelEndRepairModal';
import { SettingsController } from './Controllers/Settings/Settings';
import { SpineConst } from './Constants/SpineConst';
import { ftueController } from './Controllers/FTUE/FTUEController';
import { filters } from 'pixi.js';
import { ErrorModal } from './Controllers/ErrorModal';
import { FallingSnow } from './Utils/FallingSnow';
import { CreditsModalScreen } from './Controllers/Settings/CreditsModal';
import { AnimationContents } from '../AnimationContents';
import { ModalsManager } from './Common/MadalsManager/Core';
import { ModalsNames } from './Common/MadalsManager/ModalsList';

export interface IRootControllerOptions {
}

export class RootController extends SimpleBaseController {
    $model: GameModel;
    private blur: filters.BlurFilter;
    private snow: FallingSnow;
    private fallingSnow = false;
    private initialized: boolean = false;
    public constructor(
        @Inject private _options: IRootControllerOptions,
        @Inject private _gameLogic: GameLogic,
        @Inject private _gameStorage: GameStorageManager,
        @Inject private _backend: Backend,
    ) {
        super('RootController');
        this._gameStorage.setGameId('race-1inch');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        window["coins"] = this.$model;
        this.snow = new FallingSnow(this);

        const events = {};
        events[LevelEvents.showUI] = () => {

        };
        events[EngineEvents.musicLoudness] = () => {
            this.soundManager.changeVolume(Sounds.MUSIC_TRACK_1, SoundModel.music_level);
            this.soundManager.changeVolume(Sounds.MUSIC_TRACK_2, SoundModel.music_level);
            this.soundManager.changeVolume(Sounds.MUSIC_MENU, SoundModel.music_level);
        };
        events[UIEvents.showFTUE] = () => {
            this.addChildController({
                controller: ftueController,
                model: this.$model,
                options: {
                    close: () => {
                        this.removeChildControllerByName("ftue");
                        this.$model.pause = false;
                    }
                }
            }, "ftue");
        }
        events[UIEvents.showError] = () => {
            this.$model.pause = true;
            this.addChildControllerAsync({
                controller: ErrorModal,
                model: this.$model,
                options: {
                    closeCb: () => {
                        this.removeChildControllerByNameAsync("error");
                        this.$model.pause = false;
                    }
                }
            },
                false,
                "error"
            );
        }
        events[UIEvents.showCredits] = () => {
            this.$model.pause = true;
            this.addChildControllerAsync({
                controller: CreditsModalScreen,
                model: this.$model,
                options: {
                    exit: () => {
                        this.removeChildControllerByNameAsync("credits");
                        this.$model.pause = false;
                    }
                }
            },
                false,
                "credits"
            );
        }

        const resources = {};

        Object.keys(AnimationContents).forEach(key=>{
            resources[key] = new ResourceItem(key, AnimationContents[key], ResourceItemType.pixiAnimation);
        });

        return {
            childControllers: {
                /*
                OrientationScreen: {
                    controller: OrientationScreenController,
                    model: this.$model,
                },
                Fullscreen: {
                    controller: FullScreenController,
                    model: this.$model,
                },
                 */
            },
            resources,
            modelWatch: {
                pause: (pause: boolean) => {
                    this.showBlur(pause);

                },
                appState: (state: AppStateEnum) => {
                    this.fallingSnow = false;
                    if (this.snow) {
                        this.display.removeChild(this.snow);
                    }
                    this.removeChildControllerByName('screen');
                    this.removeChildControllerByName('levelUI');
                    switch (state) {
                        case AppStateEnum.name:
                             this.addChildControllerAsync(
                                {
                                    controller: NameScreenController,
                                    model: this.$model,
                                    options: <INameScreenOptions>{},
                                },
                                true,
                                'screen',
                                0,
                            ).then(() => this.showBlur(this.$model.pause));

                            break;
                        case AppStateEnum.game:
                             this.addChildControllerAsync(
                                {
                                    controller: GameScreenController,
                                    model: this.$model,
                                    options: <IGameScreenControllerOptions>{},
                                },
                                false,
                                'screen',
                                0,
                            );
                            this.addChildController(
                                {
                                    controller: UIController,
                                    model: this.$model,
                                    options: <IUIOptions>{},
                                },
                                'levelUI',
                                1
                            );
                            try{
                            setTimeout(() => this.showBlur(this.$model.pause), 100)}
                            catch(e){
                                //just do nothing
                            }

                            break;

                        case AppStateEnum.garage:
                             this.addChildControllerAsync(
                                {
                                    controller: GarageScreenController,
                                    model: this.$model,
                                    options: <IGarageScreenControllerOptions>{},
                                },
                                false,
                                'screen',
                                0,
                            );
                            break;

                        case AppStateEnum.levelSelector:
                             this.addChildControllerAsync(
                                {
                                    controller: LevelSelectionScreen,
                                    model: this.$model,
                                    options: <ILevelSelectionScreenOptions>{},
                                },
                                true,
                                'screen',
                                0,
                            );
                            break;

                        case AppStateEnum.endscreen:
                             this.addChildController(
                                {
                                    controller: LevelEndController,
                                    model: this.$model,
                                    options: <ILevelEndOptions>{},
                                },
                                'screen',
                                0,
                            );
                            break;

                        case AppStateEnum.leaderboard:
                        case AppStateEnum.leaderboardFromGarage:
                             this.addChildControllerAsync(
                                {
                                    controller: LeaderboardScreenController,
                                    model: this.$model,
                                    options: <ILeaderboardScreenControllerOptions>{
                                        fromGarage: state === AppStateEnum.leaderboardFromGarage
                                    },
                                },
                                true,
                                'screen',
                                0,
                            );
                            break;

                        default:
                    }

                },
            },
            modelEvents: events,
        };
    }

    protected async onInitialize() {
        this.blur = new filters.BlurFilter(2, 0.5, 0.25);
        this._gameLogic.modalsManager = new ModalsManager(this);
        try { this._gameLogic.modalsManager.preloadModal(ModalsNames.ftue, AnimationContents.FTUE_JSON); }    
        catch (e){
            alert(e);
        }   
        const isBackendEnabled = searchParam('backend');
        const isBackendTestCompleteEnabled = searchParam('testComplete');

        if (typeof isBackendEnabled !== 'undefined' && isBackendEnabled !== '') {
            this._backend.setEnabled(isBackendEnabled === '1');
        }

        await this._backend.auth();
        this.$model.loadFromBackend(await this._backend.loadState());

        await this._backend.saveState(this._backend.getState())

        // DEBUG
        if (typeof isBackendTestCompleteEnabled !== 'undefined' && isBackendTestCompleteEnabled !== '') {
            const startTimestamp = Math.round(+new Date() / 1000);

            setTimeout(() => {
                this._backend.sendComplete(
                    startTimestamp,
                    Math.round(+new Date() / 1000),
                    0,
                    0,
                    999,
                    999,
                );
            }, 3 * 1000);
        }

        if (!this.$model.playerName || this.$model.playerName === '') {
            this._gameLogic.setState(AppStateEnum.name);
        } else {
            this._gameLogic.setState(AppStateEnum.garage);
        }



        const collectablesSpineRes = new ResourceItem("collectables_spine", '/images/spine/collectables/collectables_assets_for_animation.json');
        const vfxBoomRes = new ResourceItem(SpineConst.VFXExplosion, "/images/spine/vfx_explosion/vfx_explosion.json");
        const policeVaz = new ResourceItem(SpineConst.PoliceVaz, "/images/spine/car_cops_vaz/cops_vaz.json");
        const policeFord = new ResourceItem(SpineConst.PoliceFord, "/images/spine/car_cops_ford/cops_ford.json");
        const vfxMoney = new ResourceItem(SpineConst.VFXMoney, "/images/spine/coin_fx/skeleton.json");
        const lowFuel = new ResourceItem(SpineConst.LowFuel, "/images/spine/low_fuel/low_fuel.json");
        const horse = new ResourceItem(SpineConst.horse, '/images/spine/unicorn/unicorn.json');
        const unicornVfxMoney = new ResourceItem(SpineConst.VFXUMoney, '/images/spine/unicon_fx/skeleton.json');
        this.resourcesLoader.load('spineResources', [
            collectablesSpineRes, vfxBoomRes, policeVaz, policeFord, vfxMoney, lowFuel, horse, unicornVfxMoney,
            new ResourceItem(SpineConst.level1City, '/images/spine/cities/level1/location_1.json'),
            new ResourceItem(SpineConst.level2City, '/images/spine/cities/level2/location_2.json'),
        ], () => {
            this.$model.spineResources = this.resourcesLoader.loader.resources;
            console.log(this.$model.spineResources);
        }, this);


        this.addChildControllerAsync({
            controller: SettingsController,
            model: this.$model,
            options: {
                parent: this,
            }
        }, false, "settingsScreenController");

        this.addChildControllerAsync({
            controller: RepairModalController,
            model: this.$model,
            options: {
                parent: this,
            }
        },
            false,
            'repairScreenModal'
        );


        
        this.initialized = true;
        // this.snow = new FallingSnow(this);
        // this.snow.genParticles();
        // this.display.addChild(this.snow);
        this.snow.genParticles();
        PIXI.settings.CAN_UPLOAD_SAME_BUFFER = true;
        PIXI.settings.SPRITE_BATCH_SIZE = 2048;
        // this.$model.coins = 0;
    }

    protected onUpdate(frameRate: number): void {
        if (this.fallingSnow)
            this.snow.updateParticles(frameRate);
    }

    protected onResize(width: number, height: number, scale: number): void {
        // this.snow.x = -width/scale/2;
        if ((width / scale != this.snow.particleWidth) || (height / scale != this.snow.particleHeight)) {
            this.snow.particleWidth = width / scale;
            this.snow.particleHeight = height / scale;
            this.snow.genParticles();
        }
        window["snow"] = this.snow;
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }


    showBlur(show: boolean = false) {
        try {
            const screen = this.$childControllers.get("screen");
            if (screen.display && this.initialized && this.$childControllers.get("screen"))
                if (show) {
                    this.$childControllers.get("screen").display.filters = [this.blur];
                }
                else {
                    this.$childControllers.get("screen").display.filters = [];
                }
            screen.display.interactiveChildren = !this.$model.pause;
        }
        catch (e) {
            console.log("show blur error", e)
        }
    }



}
